


















































































































































































































































































import $ from 'jquery';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { NormsServices } from '../api/NormsServices';
import Loading from 'vue-loading-overlay';
import multiselect from 'vue-multiselect';
import ConfirmationDialog from '../../core/components/ConfirmationDialog.vue';
import Input from '../../core/components/Input.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    getUniqueId,
    getAlertColorByPriority,
    getIndexFromList
} from '../../core/utils';
import Sortable from 'sortablejs';
import { uuid } from 'vue-uuid';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import { config } from 'rxjs';

@Component({
    components: {
        ConfirmationDialog,
        multiselect,
        Loading,
        Input,
        SimpleTable
    }
})
export default class EditCalculatedParameter extends Mixins(
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
) {
    @Prop() filteredParams: any;
    @Prop() calculationTypes: any;
    @Prop() paramToEdit: object;
    @Prop() calculatedSelectedParams: any;
    @Prop() selectedParams: any;
    @Prop() visible: boolean;
    @Prop() editing: boolean;
    @Prop({default: false}) modifyingSelectedCalculatedParam: boolean;
    @Prop() updateOriginal: boolean;
    @Prop({default: false}) createCalculationFromOther: boolean;
    actionConfirmDialog: string = '';
    paramsList: any = [];
    showModal: boolean = false;
    showConfirmationDialog: boolean = false;
    modifyingParameter: boolean = false;
    pendingRequest: boolean = false;
    loadingText: string = '';
    modalTitle: string = '';
    solicitedVariableSelected: any = '';
    involvedVariableSelected: any = null;
    calculoSelected: string = '';
    period: any = '';
    description: string = '';
    involvedVars: any = [
        {
            label: 'ECU',
            value: '',
            options: ['1', '2', '3']
        },
        {
            label: 'Categoría',
            value: '',
            options: ['1', '2', '3']
        },
        {
            label: 'Frame',
            value: '',
            options: ['1', '2', '3']
        },
        {
            label: 'Variable',
            value: '',
            options: ['1', '2', '3']
        }
    ];
    selectedParamsTable: any = [];
    itemsTable: any = [];
    deleteConfirmationTitle: string = '¿Está seguro que desea guardar este cálculo?';
    deleteConfirmationMessage: string = 'Esté cálculo quedará permanente en el sistema';
    paramToRemove: object = {};
    calculatedParamToEdit: object = {};
    errorResponse: any = {};
    msgLoadingDialog: string = '';
    successPost: boolean | null = null;

    mounted() {
        this.$nextTick(() => {
            let vm = this;
            let table = this.tableSelectedParams.$el.querySelector('tbody');
            const _self = this;
            Sortable.create(table, {
                handle: '.handle', // Use handle so user can select text
                onEnd({ newIndex, oldIndex }) {
                    const rowSelected = _self.itemsTable.splice(oldIndex, 1)[0]; // Get the selected row and remove it
                    _self.itemsTable.splice(newIndex, 0, rowSelected); // Move it to the new index
                }
            });
        });

        let baseTitle = 'Crear nuevo cálculo';
        if (this.editing) {
            this.loadDataForEdition();
            baseTitle = `Modificar cálculo: `
            if(this.createCalculationFromOther){
                baseTitle = `Crear cálculo a partir de: `
            }
            baseTitle += `<span class='fs-14'>${this.paramToEdit['description']}</span>`
        }

        this.modalTitle = baseTitle;
    }

    updatePeriod(value){
        this.period = value;
    }

    updateDescription(value){
        this.description = value;
    }

    loadDataForEdition() {
        //Cargo los datos para el path o crear a partir de otro
        this.description = this.paramToEdit['description'];
        this.period = this.paramToEdit['period'];
        let calculationSelected = this.calculationTypes.filter(t => t['id'] == Number(this.paramToEdit['type']));
        this.calculoSelected = calculationSelected[0];
        let solicitedVariable = {
            id: this.paramToEdit['solicited']['id'],
            description: this.paramToEdit['solicited']['variable']['description'],
            $isDisabled: true
        }

        this.solicitedVariableSelected = solicitedVariable;
        


        let itemsInvolvedVars: any = [];
        let involvedList = this.paramToEdit['involved_list'];

        if (involvedList && involvedList.length == 0) {
            this.involvedVariableSelected = null;
        } else {
            for (let i = 0; i < involvedList.length; i++) {
                //checkeo si la involucrada fue seleccionada
                let item = involvedList[i];
                let itemExistInSelectedOnes: any = this.checkIfParamExistInSelectedOnes(item['id']);
                this.$set(item, 'customId', String(uuid.v1()));
                if (itemExistInSelectedOnes == -1) {
                    this.$set(item, 'alerts', {
                        count: 1,
                        messages: [
                            {
                                description: 'Este parámetro no está dentro de los seleccionados'
                            }
                        ]
                    });
                } else {
                    this.$set(item, 'alerts', {
                        count: 0,
                        messages: []
                    });
                }
                itemsInvolvedVars.push(item);
            }
            this.itemsTable = itemsInvolvedVars;
        }
    }

    updateSelectedParamsTable(rows){
        this.selectedParamsTable = rows;
    }

    checkIfParamExistInSelectedOnes(id) {
        return getIndexFromList(this.selectedParams, 'id', id);
    }

   triggerSubmit() {
        if(!this.editing || this.createCalculationFromOther){
            this.createCalculation();
            return
        }
        this.modifyParameter();
    }

    getBadgeColor() {
        return getAlertColorByPriority();
    }

    pendingLoadingDialog(msg){
        this.$_showLoadingDialog(msg);
    }
    handleSuccessAction(response){
        this.$_successLoadingDialog({
            response: response
        });
    }
    handleErrorAction(error, alternative_msg){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg
        });
    }

    modifyParameter() {
        let configuration = this.getConfiguration();
        let self = this;

        if (this.updateOriginal) {
            //update parameter in classification list
            self.modifyingParameter = true;
            self.pendingLoadingDialog('Modificando cálculo...')
            self.scrollToTopOfModal();
            self.clearScrollLoadingDialog();

            NormsServices.patchCalculatedParameter(configuration, self.paramToEdit['id'])
                .then(response => {
                    // console.log("protocolo creado", response);
                    self.$_successLoadingDialog({
                        response: response,
                        alternative_msg: 'Calculo modificado correctamente'
                    });
                    self.closeModal();
                    let calculation = response['data'];
                    calculation['customId'] = self.paramToEdit['customId'];
                    self.$emit('update-calculation', calculation);
                })
                .catch(error => {
                   self.handleErrorAction(error, 'No se pudo modificar el parámetro calculado')
                });
        } else {
            //update calculated selected parameter
            this.$emit('modify-calculated-parameter', configuration);
            this.closeModal();
        }
    }

    confirmationDialogVisibility(value) {
        this.showConfirmationDialog = value;
    }

    resetConfirmationDialog() {
        this.actionConfirmDialog = '';
        this.deleteConfirmationTitle = '';
        this.deleteConfirmationMessage = '';
        this.paramToRemove = {};
    }

    get getHeadersTable() {
        if (!this.editing) {
            return [
                {
                    text: '',
                    align: 'center',
                    sortable: false,
                    value: 'handle',
                    class: 'short-column'
                },
                {
                    text: 'Ecu',
                    align: 'center',
                    value: 'ecu.description'
                },
                {
                    text: 'Category',
                    align: 'center',
                    value: 'category.description'
                },
                {
                    text: 'Frame',
                    align: 'center',
                    value: 'frame.description'
                },
                {
                    text: 'Variable',
                    align: 'center',
                    value: 'variable.description'
                },
                {
                    text: 'Acciones',
                    align: 'center',
                    value: 'actions'
                }
            ];
        } else {
            return [
                {
                    text: '',
                    align: 'center',
                    sortable: false,
                    value: 'handle',
                    class: 'short-column'
                },
                {
                    text: 'Ecu',
                    align: 'center',
                    value: 'ecu.description'
                },
                {
                    text: 'Category',
                    align: 'center',
                    value: 'category.description'
                },
                {
                    text: 'Frame',
                    align: 'center',
                    value: 'frame.description'
                },
                {
                    text: 'Variable',
                    align: 'center',
                    value: 'variable.description'
                },
                {
                    text: 'Alertas',
                    align: 'center',
                    value: 'alerts'
                },
                {
                    text: 'Acciones',
                    align: 'center',
                    value: 'actions'
                }
            ];
        }
    }

    get canSubmit() {
        let involvedListHasAlerts = this.itemsTable.some(item => {
            return item.hasOwnProperty('alerts') && item['alerts']['count'] > 0;
        })
        if (
            this.description !== '' &&
            this.solicitedVariableSelected !== '' &&
            this.calculoSelected !== '' &&
            this.period !== '' &&
            involvedListHasAlerts
        ) {
            return false;
        }
        
        return true;
        
    }

    get tableSelectedParams(): HTMLFormElement {
        return this.$refs.table2 as HTMLFormElement;
    }

    handleListenKey(value: boolean) {
        if (value) {
            this.$_disableListenkey();
        } else {
            this.$_enableListenkey();
        }
    }

    filterTooltipsMessages(messages, title?) {
        if (messages !== undefined) {
            let allMessages: any = [];
            for (let i = 0; i < messages.length; i++) {
                if (messages[i].description) {
                    allMessages.push('- ' + messages[i].description + '<br>');
                } else {
                    if (title) {
                        allMessages.push(title + '<br>');
                    }
                    allMessages.push('- ' + messages[i] + '<br>');
                }
            }
            allMessages = allMessages.filter(function(elem, index, self) {
                return index === self.indexOf(elem);
            });
            return allMessages.toString().replace(/,/g, '');
        } else {
            return '';
        }
    }

    selectParam() {
        // console.log("involucrada", this.involvedVariableSelected);
        // console.log("seleccionados", this.selectedParams);
        let indexParamInSelectedOnes = getIndexFromList(this.selectedParams, 'id', this.involvedVariableSelected['id']);
        let indexParamPreviouslySelected = getIndexFromList(this.itemsTable, 'id', this.involvedVariableSelected['id']);
        let paramToAdd;
        if (indexParamPreviouslySelected == -1) {
            if (indexParamInSelectedOnes !== -1) {
                paramToAdd = JSON.parse(JSON.stringify(this.selectedParams[indexParamInSelectedOnes]));
            }
        } else {
            paramToAdd = paramToAdd = JSON.parse(JSON.stringify(this.itemsTable[indexParamPreviouslySelected]));
        }

        this.$set(paramToAdd, 'alerts', {
            count: 0,
            messages: []
        });
        this.$set(paramToAdd, 'customId', getUniqueId());
        this.itemsTable.push(paramToAdd);
    }

    checkIfIDExistsInArray(arr, id) {
        if (arr.find(a => a.id === id)) {
            return true;
        } else {
            return false;
        }
    }

    createCalculation() {
        this.actionConfirmDialog = 'save_calculation';
        this.deleteConfirmationTitle = '¿Está seguro que desea guardar este cálculo?';
        this.deleteConfirmationMessage = 'Esté cálculo quedará permanente en el sistema';
        this.confirmationDialogVisibility(true);
    }

    getSolicitedId(id) {
        for (let i = 0; i < this.selectedParams.length; i++) {
            let item = this.selectedParams[i];
            if (item['variable']['id'] === id) {
                return parseInt(item['id']);
            }
        }
    }

    submitCalculation() {
        let configuration = this.getConfiguration();
        let self = this;
        self.modifyingParameter = true;
        self.pendingLoadingDialog('Generando cálculo...')
        self.scrollToTopOfModal();
        self.clearScrollLoadingDialog();
        NormsServices.postCreateCalculatedParameter(configuration)
            .then(response => {
                self.$_successLoadingDialog({
                    response: response,
                    alternative_msg: 'Calculo generado correctamente'
                });
                self.closeModal();
                self.$emit('add-new-calculation', response);
            })
            .catch(error => {
                self.handleErrorAction(error, 'No se pudo crear el parámetro calculado');
            }).finally(() => {
                self.modifyingParameter = false;
            })
    }

    getConfiguration() {
        let involvedListIds: number[] = [];
        let configuration = {};

        if(this.itemsTable.length > 0){
            involvedListIds = this.itemsTable.map(item => Number(item['id']));
        }

        configuration = {
            description: this.description,
            period: Number(this.period),
            type: Number(this.calculoSelected['id']),
            solicited: Number(this.solicitedVariableSelected['id']),
            involved: involvedListIds
        };

       

        if(this.editing) {

            if(this.createCalculationFromOther){
                if(configuration.hasOwnProperty('id')){
                    delete configuration['id'];
                }
            }

            if (this.modifyingSelectedCalculatedParam) {
                //SI modifico el calculo desde los calculos seleccionados
                //Agrego estas keys para poder actualizarlo en la tabla de seleccionados
                this.$set(configuration, 'customId', this.paramToEdit['customId']);
                this.$set(configuration, 'id', this.paramToEdit['id']);
                this.$set(configuration, 'involved', this.itemsTable);
                this.$set(configuration, 'solicited_description', this.solicitedVariableSelected['description']);
            }
        }

        return configuration;
    }

    removeParameter(item) {
        this.paramToRemove = item;
        this.actionConfirmDialog = 'exclude_parameter';
        this.deleteConfirmationTitle = 'Excluir parámetro';
        this.deleteConfirmationMessage = '¿Está seguro que desea excluir el parámetro seleccionado?';
        this.confirmationDialogVisibility(true);
    }

    triggerAction() {
        this.confirmationDialogVisibility(false);
        if (this.actionConfirmDialog === 'exclude_parameter') {
            this.excludeParameter();
        } else {
            this.submitCalculation();
        }
        this.resetConfirmationDialog();
    }

    excludeParameter() {
        for (let i = 0; i < this.itemsTable.length; i++) {
            let paramToRemove = getIndexFromList(this.itemsTable, 'customId', this.paramToRemove['customId']);
            if (paramToRemove !== -1) {
                this.itemsTable.splice(paramToRemove, 1);
            }
        }
    }

    scrollToTopOfModal() {
        $('.scroll-edit-calculated-param').scrollTop(0);
    }

    clearScrollLoadingDialog() {
        $('html').css('overflow-y', 'hidden');
        $('.scroll-edit-calculated-param').css('overflow-y', 'hidden');
    }

    enableScrollLoadingDialog() {
        $('.scroll-edit-calculated-param').css('overflow-y', 'auto');
        $('html').css('overflow-y', 'auto');
    }

    handleCatchResponse(error) {
        let self = this;
        self.successPost = false;
        self.errorResponse = {};
        if (error && error.response && error.response.data && error.response.data.message) {
            self.msgLoadingDialog = error.response.data.message;
        } else {
            self.msgLoadingDialog = 'Ocurrió un error';
            self.errorResponse = error.response.data;
        }
        self.scrollToTopOfModal();
        self.clearScrollLoadingDialog();
    }

    @Emit()
    closeModal() {}
}
